'use es6';

import Actions from 'AdsUI/lib/Actions';
import { List } from 'immutable';
import AdAccountOverviewRecord from 'AdsUI/records/ad-accounts/AdAccountOverviewRecord';
export default ((state = List(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.SELECTED_AD_ACCOUNTS_FETCH_SUCCEEDED:
    case Actions.AD_ACCOUNTS_OVERVIEW_FETCH_SUCCEEDED:
      {
        // earlyRequester (SELECTED_AD_ACCOUNTS_FETCH_SUCCEEDED) returns an array
        // fetchOverview (AD_ACCOUNTS_OVERVIEW_FETCH_SUCCEEDED) returns an object with an accounts key
        const accounts = Array.isArray(payload) ? payload : payload.accounts;
        return List(accounts.map(account => new AdAccountOverviewRecord(account)));
      }

    default:
      return state;
  }
});